import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ルート変更のたびに先頭へ戻す。
 *
 * react-router は既定でスクロール位置を持ち越すので、トップを下まで読んでから
 * 「歌詞を見る」を押すと**歌詞ページの途中に着地する**（2026-08-15 に実測）。
 * 描画しないので BrowserRouter の中に置くだけでよい。
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
